var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_1297)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.1428,
    cy: 12,
    r: 12,
    fill: "#F4C600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74292 16.8V8.475H9.21792V6H15.0679V10.95H17.5429V16.8H12.9379V14.325H11.3479V16.8H6.74292ZM7.64292 15.9H9.21792V14.325H7.64292V15.9ZM7.64292 13.425H9.21792V11.85H7.64292V13.425ZM7.64292 10.95H9.21792V9.375H7.64292V10.95ZM10.1179 13.425H11.6929V11.85H10.1179V13.425ZM10.1179 10.95H11.6929V9.375H10.1179V10.95ZM10.1179 8.475H11.6929V6.9H10.1179V8.475ZM12.5929 13.425H14.1679V11.85H12.5929V13.425ZM12.5929 10.95H14.1679V9.375H12.5929V10.95ZM12.5929 8.475H14.1679V6.9H12.5929V8.475ZM15.0679 15.9H16.6429V14.325H15.0679V15.9ZM15.0679 13.425H16.6429V11.85H15.0679V13.425Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_1297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.142822)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipo02);
export default __webpack_public_path__ + "static/media/tipo-02.e139c6d5649d12ea22962a69907a5a77.svg";
export { ForwardRef as ReactComponent };